import { render, staticRenderFns } from "./AppTabbar.vue?vue&type=template&id=7f66fea6&scoped=true&"
import script from "./AppTabbar.vue?vue&type=script&lang=js&"
export * from "./AppTabbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f66fea6",
  null
  
)

export default component.exports